import React from 'react';
import ReactDOM from 'react-dom/client';
import './global.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import store from './store';
import { StyledEngineProvider } from '@mui/material/styles';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <Provider store={store}>
        <StyledEngineProvider injectFirst>
            <React.StrictMode>
                <App />
            </React.StrictMode>
        </StyledEngineProvider>
    </Provider>
);

reportWebVitals();